import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { red } from '@mui/material/colors';
import InfoBlock from '../../InfoBlock/InfoBlock';

/**
 * Props for the ErrorInfoBlock component.
 */
interface ErrorInfoBlockProps {
  /**
   * A unique base identifier for accessibility and testing purposes.
   * This is used to generate unique IDs for elements within the component.
   */
  baseId: string;

  /**
   * The main title text displayed at the top of the InfoBlock.
   */
  title: string;

  /**
   * A subtitle providing additional context or information about the error.
   */
  subtitle: string;
}

/**
 * ErrorInfoBlock Component
 *
 * A reusable component that displays an error message using the InfoBlock component.
 * It is pre-configured with an error icon and red color to indicate an error state.
 * The component allows customization of the baseId, title, and subtitle through its props.
 */
const ErrorInfoBlock = ({ baseId, title, subtitle }: ErrorInfoBlockProps) => {
  return (
    <InfoBlock
      baseId={baseId}
      title={title}
      content="Failed to load"
      icon={<ErrorOutlineRoundedIcon sx={{ height: '28px', width: '28px' }} />}
      subtitle={subtitle}
      color={red.A400}
    />
  );
};

export default ErrorInfoBlock;
